/**
 * RiderInfoDetail Config
 * 라이더 상세정보 페이지 설정 상수
 */

// ========================================
// 은행 옵션
// ========================================

export const BANK_OPTIONS = [
    { value: '', label: '선택' },
    { value: '농협은행', label: '농협은행' },
    { value: '신한은행', label: '신한은행' },
    { value: '국민은행', label: '국민은행' },
    { value: '우리은행', label: '우리은행' },
    { value: '하나은행', label: '하나은행' },
    { value: '기업은행', label: '기업은행' },
    { value: '카카오뱅크', label: '카카오뱅크' },
    { value: '토스뱅크', label: '토스뱅크' },
] as const;

export type BankCode = typeof BANK_OPTIONS[number]['value'];

// ========================================
// 유효성 검사 규칙
// ========================================

export const ACCOUNT_NUMBER_VALIDATION = {
    MIN_LENGTH: 10,
    MAX_LENGTH: 20,
    PATTERN: /^[0-9]*$/,
    ERROR_MESSAGES: {
        REQUIRED: '계좌번호를 입력해주세요.',
        INVALID_LENGTH: '계좌번호는 10자리 이상 20자리 이하로 입력해주세요.',
        INVALID_FORMAT: '계좌번호는 숫자만 입력 가능합니다.',
    },
} as const;

export const ACCOUNT_HOLDER_VALIDATION = {
    MIN_LENGTH: 2,
    MAX_LENGTH: 20,
    PATTERN: /^[가-힣a-zA-Z\s]*$/,
    ERROR_MESSAGES: {
        REQUIRED: '예금주를 입력해주세요.',
        INVALID_LENGTH: '예금주는 2자리 이상 입력해주세요.',
        INVALID_FORMAT: '예금주는 한글, 영문, 공백만 입력 가능합니다.',
    },
} as const;

export const BANK_VALIDATION = {
    ERROR_MESSAGES: {
        REQUIRED: '은행을 선택해주세요.',
    },
} as const;
